<div class="wait-time" *ngIf="waitTime" [innerHtml]="waitTime | safeHtml"></div>
<div class="operating-status" *ngIf="status">{{status}}</div>
